import { ColorOptions, MaterialTextInput } from '@jfs/ui-new'
import { useState } from 'react'
import { CvvIcon } from '../../../assets/images/svg/Cvv'
import { InvalidCvvIcon } from '../../../assets/images/svg/InvalidCvv'
import { convertHexToRGBA } from '../../../utils'

interface CVVInputProps {
  value?: string
  innerRef?: any
  prevRef?: any
  nextRef?: any
  isTextInput?: boolean
  maxCvvLength: number
  cvv: string
  onChange: (value: string) => void
  validCvv?: boolean
  autoFocus?: boolean
  theme?: any
}

const CVV = ({ value, onChange, autoFocus = false, theme }: CVVInputProps) => {
  const [errorMsgCvv, setErrorMsgCvv] = useState('')
  const internalOnChangeCvv = (text: string) => {
    errorMsgCvv && setErrorMsgCvv('')
    const numberWithoutSpace = text.replace(/[^0-9]/g, '')
    onChange(numberWithoutSpace)
  }

  const onInternalCvvBlur = () => {
    if (!value || (value?.length < 3 && value?.length > 0)) {
      setErrorMsgCvv('Invalid CVV')
    }
  }

  const renderIcon = () => {
    if (errorMsgCvv) {
      return <InvalidCvvIcon width={30} height={30} />
    } else {
      return <CvvIcon width={30} height={30} color={theme?.brandColor as ColorOptions} />
    }
  }

  return (
    <MaterialTextInput
      autoFocus={autoFocus}
      maxLength={4}
      value={value}
      secureTextEntry={true}
      onChangeText={(text: string) => internalOnChangeCvv(text)}
      placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
      onBlur={onInternalCvvBlur}
      color={theme?.bodyTextColor}
      placeholder={'CVV'}
      keyboardType={'number-pad'}
      error={errorMsgCvv}
      testID={'cvvTextInput'}
      rightComponent={renderIcon()}
      bottomLineColor={theme?.brandColor as ColorOptions}
      tintColor={theme?.brandColor as ColorOptions}
    />
  )
}

export { CVV }
